import React, { useState } from "react";
import "./Products.css";

const allProducts = [
  // 40+ produits d'exemple
  { id: 1, name: "Line-Pattern Zipper Sweatshirt", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "q1.png"},
  { id: 2, name: "Black Fantasy Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "q2.webp"},
  { id: 3, name: "Brooklyn-NYC Sweatshirt", price: 200, oldPrice: 240, badge: "BEST SELLER" , ImageUrl: "q3.avif"},
  { id: 4, name: "Basic Plain Shirt", price: 200, oldPrice: 240, badge: "HOT PROMO" , ImageUrl: "q4.webp"},
  { id: 5, name: "Basic Orange Sweatshirt", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "t1.png"},
  { id: 6, name: "Alui Sweatshirt X Alvent G", price: 200, oldPrice: null, badge: null , ImageUrl: "t2.png"},
  { id: 7, name: "Flowers Printed Sweatshirt", price: 200, oldPrice: 240, badge: "HOT PROMO" , ImageUrl: "t3.png"},
  { id: 8, name: "Relaxed Fit Printed Sweatshirt", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "lv1.png"},
  { id: 9, name: "Letter Pattern Knitted Vest", price: 200, oldPrice: null, badge: null , ImageUrl: "lv2.webp"},
  { id: 10, name: "Pastel Green Oversized Hoodie", price: 200, oldPrice: 230, badge: null , ImageUrl: "lv3.webp"},
  { id: 11, name: "Minimal Beige Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "lv4.webp"},
  { id: 12, name: "Classic Navy Hoodie", price: 200, oldPrice: 220, badge: "HOT PROMO" , ImageUrl: "bl1.png"},
  { id: 13, name: "Street Art Printed Hoodie", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "bl2.webp"},
  { id: 14, name: "Soft Lilac Overshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "bl3.webp"},
  { id: 15, name: "Retro Graphic Sweatshirt", price: 200, oldPrice: 260, badge: "BEST SELLER" , ImageUrl: "bl4.webp"},
  { id: 16, name: "Mint Green Casual Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "bl5.webp"},
  { id: 17, name: "Warm Yellow Crewneck", price: 200, oldPrice: 230, badge: null , ImageUrl: "bl6.webp"},
  { id: 18, name: "Ocean Blue Zip Hoodie", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "bl7.webp"},
  { id: 19, name: "Soft Brown Fleece Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "n1.webp"},
  { id: 20, name: "Vintage Logo Hoodie", price: 200, oldPrice: 240, badge: "HOT PROMO" , ImageUrl: "n2.avif"},
  { id: 21, name: "Gradient Purple Sweatshirt", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "n3.avif"},
  { id: 22, name: "College Team Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "n4.avif"},
  { id: 23, name: "Oversized White Hoodie", price: 200, oldPrice: 230, badge: null , ImageUrl: "n5.avif"},
  { id: 24, name: "Soft Pink Crewneck", price: 200, oldPrice: null, badge: null , ImageUrl: "n6.webp"},
  { id: 25, name: "Colorblock Street Hoodie", price: 200, oldPrice: 250, badge: "HOT PROMO" , ImageUrl: "q1.png"},
  { id: 26, name: "Sporty Zip Sweatshirt", price: 200, oldPrice: null, badge: "NEW" , ImageUrl: "q1.png"},
  { id: 27, name: "Urban Printed Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 28, name: "Pastel Yellow Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 29, name: "Clean White Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 30, name: "Orange Gradient Hoodie", price: 200, oldPrice: 220, badge: null , ImageUrl: "q1.png"},
  { id: 31, name: "Graphic Comic Sweatshirt", price: 200, oldPrice: 260, badge: "BEST SELLER" , ImageUrl: "q1.png"},
  { id: 32, name: "Soft Green Basic Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 33, name: "Deep Blue Crewneck", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 34, name: "Relaxed Grey Hoodie", price: 200, oldPrice: 230, badge: "HOT PROMO" , ImageUrl: "q1.png"},
  { id: 35, name: "Vintage Print Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 36, name: "Patchwork Color Hoodie", price: 200, oldPrice: 250, badge: "NEW" , ImageUrl: "q1.png"},
  { id: 37, name: "Monochrome Oversized Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 38, name: "Street Typography Sweatshirt", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 39, name: "Sky Blue Basic Hoodie", price: 200, oldPrice: null, badge: null , ImageUrl: "q1.png"},
  { id: 40, name: "Neon Trim Sweatshirt", price: 200, oldPrice: 240, badge: "HOT PROMO" , ImageUrl: "q1.png"},
];

const PAGE_SIZE = 24;

const Products = () => {
  const [currentPage, setCurrentPage] = useState(1);
  //const [showDetails , setShowDetails] = useState(false);

  const totalPages = Math.ceil(allProducts.length / PAGE_SIZE);

  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const currentProducts = allProducts.slice(
    startIndex,
    startIndex + PAGE_SIZE
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="products-page">
      <div className="products-header">
        <div className="products-breadcrumb">
          <span>Main Page</span> <span className="crumb-sep">{">"}</span>
          <span>Category</span> <span className="crumb-sep">{">"}</span>
          <span className="crumb-current">Sweatshirt</span>
        </div>

        <h1 className="products-title">Sweatshirt</h1>

        <div className="products-top-row">
          <div className="products-filters">
          </div>

          <div className="products-sort">
            <input 
            type="text"
            placeholder="Rechercher un produit..."
            />
          </div>
        </div>
      </div>

      {/* GRID PRODUITS */}
      <div className="products-grid">
        {currentProducts.map((product) => (
          <article className="product-card" key={product.id}>
            <div className="product-card-inner">
              {/* <header className="product-card-header">
                {product.badge && (
                  <span className="product-badge">
                    {product.badge}
                  </span>
                )}
                
              </header> */}

              {/* image placeholder */}
              <div className="product-image-wrapper">
                <img
                    src={product.ImageUrl}
                    alt={product.name}
                    className="product-image"
                />
                </div>


              <div className="product-info">
                <h2 className="product-name">{product.name}</h2>

                <div className="product-price-row">
                  <div className="product-price-block">
                    <span className="product-price-label">Price:</span>
                    <div className="product-price-values">
                      <span className="product-price">
                        ${product.price}
                      </span>
                      {product.oldPrice && (
                        <span className="product-old-price">
                          ${product.oldPrice}
                        </span>
                      )}
                    </div>
                  </div>

                  <button
                    className="product-cart-btn"
                    aria-label="Add to cart"
                  >
                    Acheter
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>

      {/* PAGINATION */}
      <div className="products-pagination">
        <button
          className="pagination-nav"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="pagination-pages">
          {Array.from({ length: totalPages }).map((_, index) => {
            const page = index + 1;
            return (
              <button
                key={page}
                className={`pagination-page ${
                  page === currentPage ? "pagination-page--active" : ""
                }`}
                onClick={() => goToPage(page)}
              >
                {page}
              </button>
            );
          })}
        </div>

        <button
          className="pagination-nav"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Suivant
        </button>
      </div>
    </div>
  );
};

export default Products;
